<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-user-list [listType]="DtgListType.list"></dtg-manage-user-list>
    </div>
</div>